<template>
    <div class="">
        <div class="">
            <img src="../../assets/images/real_banner.png" class="real_topImg" />
        </div>
        <div class="real_con">
            <div class="">
                <div class="real_head">
                    <div class="fontS36 real_pos fontW600">优质真人主播</div>
                    <div class="real_boxY"></div>
                    <div class="fontS18 fontC">定制您的专属配音作品</div>
                </div>
            </div>
            <div class="real_sticky2 real_padB20">
                <div class="real_flex1 with1000">
                    <div class="real_button hover_hand" :class="butIndex == index ? 'real_bac1' : ''" v-for="(tabItem, index) in buttonList" :key="index" @click="butIndex = index">
                        {{ tabItem.catname }}
                    </div>
                </div>
            </div>

            <div class="" v-for="(item, index) in buttonList" :key="index" v-if="butIndex == index">
                <div class="real_flexDR real_flexWW">
                    <div class="real_zbItem real_marR24" v-for="(item2, index2) in item.list" :key="index2" @click="showModal = true; getDetail(item2);">
                        <div class="real_flexDR real_borderB real_pad20">
                            <img :src="item2.cover" alt="" class="real_marR20 index_mod2_liavater" />
                            <div class="">
                                <div class="real_flexDR real_flexAC">
                                    <div class="fontS18 real_marR16 fontW600">
                                        {{ item2.speakername }}
                                    </div>
                                    <div class="real_box fontS12">在线</div>
                                </div>
                                <div>
                                    <div class="fontS14 real_fontC1 real_leable overflow_hide">
                                        {{ item2.fittype }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="real_outer">
                            <div class="real_inner">
                                <div class="real_padL20 real_padR20" v-for="item3 in item2.soundinfo">
                                    <div class="real_pad real_flexSB">
                                        <div class="real_fontC2 real_fontS14 real_padB16 real_soundName">
                                            <p class="overflow_hide fontS14">{{ item3.soundname }}</p>
                                            <div class="real_flexDR real_flexAC">
                                                <img src="../../assets/images/img1/real_label.png" alt="" style="width: 10px; height: 10px; margin-right: 5px" />
                                                <p class="real_fontC1 fontS12">
                                                    {{ item3.label }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="real_flexDR">
                                            <div class="real_flexDR real_flexAC real_boxL real_flexJC real_marR10 hover_hand" :class=" demo_audio.audiourl == item3.soundurl ? 'real_boxChose' : '' " @click.stop="playReal(item3.soundurl)">
                                                <img src="../../assets/images/pause.png" v-if="demo_audio.audiourl == item3.soundurl" style="width: 15px; height: 15px; margin-right: 5px" />
                                                <img src="../../assets/images/play.png" v-else style="width: 15px; height: 15px; margin-right: 5px" />
                                                <span class="fontS14 ">{{demo_audio.audiourl == item3.soundurl ? "暂停" : "试听"}}</span>
                                            </div>
                                            <router-link to="/real_dubbing">
                                                <div class="real_flexDR real_flexAC real_boxL real_flexJC hover_hand">
                                                    <img src="../../assets/images/play.png" alt="" style="width: 15px; height: 15px; margin-right: 5px" />
                                                    <p class="fontS12 " @click="setReal(item2,item3)">
                                                        使用
                                                    </p>
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 弹框 -->
            <div class="real_flexJC mb" v-if="showModal" @click="showModal = false">
                <div class="real_show real_marT70">
                    <div class="real_flexDR real_borderB real_pad20 real_flexAC">
                        <img :src="anchorItem.cover" alt="" class="real_marR20 real_liavater" />
                        <div>
                            <div class="real_flexDR real_flexAC real_marB10">
                                <div class="fontS18 real_marR16">
                                    {{ anchorItem.speakername }}
                                </div>
                                <div class="fontS14 dubbing_fontCR">
                                    （{{ anchorItem.price }}元/百字）
                                </div>
                            </div>
                            <div class="real_marB10">
                                <div class="fontS14 real_fontC3">
                                    {{ anchorItem.fittype }}
                                </div>
                            </div>
                            <div class="fontS14 real_fontC1">
                                {{ anchorItem.desp }}
                            </div>
                        </div>
                    </div>

                    <div class="real_outer2">
                        <div class="real_inner">
                            <div class="real_flexWW real_flexSB">
                                <div class="real_padL20 real_padR20 real_wit" v-for="item in anchorItem.soundinfo">
                                    <div class="real_pad real_flexSB">
                                        <div class="real_fontC2 real_fontS14 real_padB16 real_hideTankuang ">
                                            <p class="overflow_hide">{{ item.soundname }}</p>
                                            <div class="real_flexDR real_flexAC">
                                                <img src="../../assets/images/img1/real_label.png" alt="" style="width: 10px; height: 10px; margin-right: 5px" />
                                                <p class="real_fontC1 fontS12">{{ item.label }}</p>
                                            </div>
                                        </div>
                                        <div class="real_flexDR">
                                            <div class=" real_flexDR real_flexAC real_boxL real_flexJC real_marR10 hover_hand " :class=" demo_audio.audiourl == item.soundurl ? 'real_boxChose' : '' " @click.stop="playReal(item.soundurl)">
                                                <img src="../../assets/images/pause.png" v-if="demo_audio.audiourl == item.soundurl" style="width: 13px; height: 13px; margin-right: 5px" />
                                                <img src="../../assets/images/play.png" v-else style="width: 13px; height: 13px; margin-right: 5px" />
                                                <span class="fontS14 ">{{ demo_audio.audiourl == item.soundurl ? "暂停" : "试听" }}</span>
                                            </div>
                                            <!-- <router-link to="/real_dubbing"> -->
                                                <div class=" real_flexDR real_flexAC real_boxL real_flexJC real_bac1 hover_hand ">
                                                    <img src="../../assets/images/enit.png" alt="" style="width: 13px; height: 13px; margin-right: 5px" />
                                                    <p class="fontS14" @click="setReal(anchorItem,item)">
                                                        使用
                                                    </p>
                                                </div>
                                            <!-- </router-link> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import PlayListAudio from "../../utils/PlayListAudio.js";
import Footer from "../../components/footer.vue";
export default {
    components: {
        Footer,
    },
    name: "real",
    data() {
        return {
            // 模板样音播放器对象
            demo_audio: new PlayListAudio(),

            butIndex: 0,
            showModal: false,
            buttonList: [],
            anchorItem: [],
        };
    },
    mounted() {
        this.getRealAnchorList();
    },
    destroyed() {
        this.demo_audio.stop();
    },
    watch: {
        $route(to, from) {
            this.demo_audio.stop();
            this.showModal = false;
        },
    },
    methods: {
        //保存全部真人主播、真人主播到vuex
        setReal(realAnchor,choseMusic) {
            // console.log(realAnchor)
            this.$router.push("/real_dubbing");
            this.demo_audio.stop();
            this.$store.commit("setChoseMusic", choseMusic);
            this.$store.commit("setRealAnchor", realAnchor);
            this.$store.commit("setAllRealAnchor", this.buttonList);
        },
        // //保存选中案例到vuex
        // setChose(choseMusic) {
        //     this.$store.commit("setChoseMusic", choseMusic);
        // },
        // 查询真人主播列表
        getRealAnchorList() {
            let self = this;
            let url =
                self.$store.state.app_api +
                self.$store.state.app_url.qryRealzhubov4;
            this.$request.postHttp({}, url, (res) => {
                console.log(res);
                this.buttonList = res.model;
            });
        },

        // 查询真人主播详情
        getDetail(item) {
            this.anchorItem = item;
        },

        // 真人配音播放事件
        playReal(url) {
            // this.stopAllMusci();
            this.demo_audio.play(url);
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/view/real/real.vue